import SafeStringify from './SafeStringify';

function SafeStringifyAxiosError(err) {
  const errorResponse = err.response.data?.message ? SafeStringify(err.response.data.message) : SafeStringify(err.response.data);

  return errorResponse;
}
export default SafeStringifyAxiosError;
